export const closeModal = () => {
  return dispatch => {
    dispatch({ type: 'CLOSE_SNACKBAR', payload: false });
  };
};
